<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  font-family: "Ubuntu", sans-serif;
  width: 100%;
  overflow-x: hidden;
}
#app {
  color: white;
  background-color: #b1b1b1;
  width: 100%;
  min-height: 100vh;
}
@media (max-width: 768px) {
  #app {
    text-align: center;
  }
}
</style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease-out;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
